<!--
 * @Author: your name
 * @Date: 2021-06-22 15:56:05
 * @LastEditTime: 2021-06-22 16:00:26
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \ecfc-oms-facade\src\views\home\components\EcMenu\Link.vue
-->
<template>
  <component :is="type" v-bind="linkProps(to)">
    <slot />
  </component>
</template>

<script>
import { isExternal } from '@/common/utils/validate'

export default {
  props: {
    to: {
      type: String,
      required: true
    }
  },
  computed: {
    isExternal() {
      return isExternal(this.to)
    },
    type() {
      if (this.isExternal) {
        return 'a'
      }
      return 'router-link'
    }
  },
  methods: {
    linkProps(to) {
      if (this.isExternal) {
        return {
          href: to,
          target: '_blank',
          rel: 'noopener'
        }
      }
      return {
        to: to
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/home/components/EcMenu/Link.vue